isInViewport = (elem) -> if elem?
  bounding = elem.getBoundingClientRect()
  bounding.top >= 0 and
  bounding.left >= 0 and
  bounding.bottom <= (window.innerHeight or document.documentElement.clientHeight) and
  bounding.right <= (window.innerWidth or document.documentElement.clientWidth)

module.exports = isInViewport
